import { Controller } from "stimulus"

// Reveals the GL account form's nested capital asset mapping sub-form only
// when the account is becoming Capital Outlay in a proprietary fund: the
// classification or fund differs from the saved one held in
// data-capital-mapping-subform-classification / -fund, so an account saved
// that way before the invariant existed can still be edited. While hidden its
// fields are disabled so they are not submitted; while shown the required
// fields are marked required so the browser blocks an incomplete save. When a
// change reveals it, the always-present status region announces it, since
// focus stays on the select that was changed.
export default class extends Controller {
  static targets = ["classification", "fund", "panel", "required", "status"]

  connect() {
    this.toggle({ announce: false })
  }

  toggle({ announce = true } = {}) {
    if (!this.hasPanelTarget) return

    const show = this.mappingNeeded()
    const revealed = show && this.panelTarget.hidden
    this.panelTarget.hidden = !show
    this.panelTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !show
    })
    this.requiredTargets.forEach((field) => {
      field.required = show
    })
    this.announce(revealed && announce ? "Capital Asset Mapping fields are now shown below. Asset Account is required." : "")
  }

  announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }

  mappingNeeded() {
    if (!this.hasClassificationTarget || !this.hasFundTarget) return false

    const fundOption = this.fundTarget.selectedOptions[0]
    const fundType = fundOption ? fundOption.getAttribute("data-fund-type") : null
    if (this.classificationTarget.value !== "capital_outlay" || fundType !== "proprietary") return false

    return this.changedFromSaved()
  }

  changedFromSaved() {
    const savedClassification = this.data.get("classification") || ""
    const savedFund = this.data.get("fund") || ""
    return this.classificationTarget.value !== savedClassification || this.fundTarget.value !== savedFund
  }
}
